module.exports = __webpack_public_path__ + "img/no_zone_selected.4fa5590f.svg";